import { DELETE_ITEM_REQUEST, DELETE_ITEM_SUCCESS, DELETE_ITEM_FAILURE } from './action';

const initialState = {
  loading: false,
  error: null,
  deletedItemId: null,
};

const deleteReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_ITEM_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_ITEM_SUCCESS:
      return { ...state, loading: false, deletedItemId: action.payload };
    case DELETE_ITEM_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default deleteReducer;
